<template>
  <van-list
    v-model="loading"
    :finished="finished"
    finished-text=""
    @load="getMyQuestion"
  >
    <div class="container">
      <div class="m-list">
        <ListItem
          v-for="(item, index) in myQuestion"
          :key="index"
          :data="item"
          @click="bindClick"
          :self="true"
        />
      </div>
      <div v-if="recommend.length">
        <div class="recommend-title">为您推荐</div>
        <div class="m-list">
          <ListItem
            v-for="(item, index) in recommend"
            :key="index"
            :data="item"
            @click="bindClick"
          />
        </div>
      </div>
    </div>
  </van-list>
</template>
<script>
import ListItem from './components/list-item.vue'
export default {
  name: 'common-questions-my-question',
  components: {
    ListItem
  },
  data() {
    return {
      loading: false,
      finished: false,
      myQuestion: [],
      recommend: []
    }
  },
  created() {},
  methods: {
    getMyQuestion(isCover) {
      this.$http
        .getBaseApp('que/QueBase/getUserQueList', {})
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            if (res.data.returnData && Array.isArray(res.data.returnData)) {
              let returnData = res.data.returnData
              for (let i = 0; i < returnData.length; i++) {
                let queId = returnData[i].id
                let version = returnData[i].version
                returnData[i] = returnData[i].que_info
                returnData[i].queId = queId
                returnData[i].version = version
                returnData[i].que_title = returnData[i].que_title.replace(
                  /<\s*br\s*\/*\s*>/g,
                  ','
                )
              }
            }
            if (isCover) {
              this.myQuestion = res.data.returnData
            } else {
              this.myQuestion = this.myQuestion.concat(res.data.returnData)
            }
            res.data.recommendQue.map((item) => {
              item.que_title = item.que_title.replace(/<\s*br\s*\/*\s*>/g, ',')
            })
            this.recommend = res.data.recommendQue || []
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
          this.finished = true
        })
    },
    bindClick(item, index) {
      if (index == 2) {
        this.$router.push({
          path: '/common-questions/result/q' + item.id,
          query: {
            que_id: item.queId,
            que_type: item.id,
            que_title: item.que_title,
            que_explain: item.que_explain,
            que_cover: item.que_cover
          }
        })
      } else {
        this.$router.push({
          path: '/common-questions/start',
          query: {
            id: item.id
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  padding: 30px 16px;
  box-sizing: border-box;
  background-color: #f9f9f9;
}

.m-list {
  margin-bottom: 10px;
}

.recommend-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 20px;
  margin-bottom: 16px;
}
</style>
